import {IonPage, IonHeader, IonContent, IonSpinner} from "@ionic/react";
import {Toolbar} from "../pages/Toolbar";

export const NoBookingDetails = ({isLoading}) => (
    <IonPage>
        <IonHeader>
            <Toolbar title="Booking" backButtonHref="/" />
        </IonHeader>
        <IonContent>
            {isLoading ? (
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '100%'
                }}>
                    <IonSpinner color='teal' />
                </div>
            ) : (
                <h3 className="ion-padding-start">No Booking Details</h3>
            )}
        </IonContent>
    </IonPage>
);
